<template lang="pug">
#usersContent
  //- div {{userList}}
  .users(v-for="(user, index) in userList" :key="index")
    el-image(:src="circleUrl(user)")
      .userAvatar(slot="error") {{userName(user.name||user.userName)}}
    .name {{ user.name || user.userName }}
    i.el-icon-delete(:class="{'noClick':disabled}" @click="deleteUser(user)")
</template>

<script>
import { gettouxAvatar } from "@/CommonDP/utils";
export default {
  props: {
    userList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      roleIcon: require("@/CommonDP/assets/doc/role.png")
    };
  },
  methods: {
    circleUrl(item) {
      const avatatDescribe = {
        0: () => {
          return gettouxAvatar(item.userId);
        },
        1: () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        2: () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        3: () => {
          return "";
        },
        4: () => {
          return "";
        }
      };
      return avatatDescribe[item.type] ? avatatDescribe[item.type]() : "";
    },
    errorHandler() {
      return true;
    },
    deleteUser(user) {
      if (this.disabled) {
        return;
      }
      this.$confirm(`确认${this.deleteToolTip(user)}:${user.name || user.userName}?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      }).then(async () => {
        this.$emit("deleteUser", user);
      }).catch(() => {
        // this.$message.info("已取消");
      });
    },
    deleteToolTip(user) {
      const tipDescribe = {
        0: () => { return "删除人员"; },
        1: () => { return "删除系统角色"; },
        2: () => { return "删除专业角色"; },
        3: () => { return "删除项目角色"; }
      };
      return tipDescribe[user.type] ? tipDescribe[user.type]() : "删除";
    },
    userName(val) {
      return val.charAt(0) || "";
    }
  }

};
</script>

<style lang="scss" scoped>
#usersContent{
  width: calc(100% - 10px);
  max-height: 170px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .users{
    padding: 5px 10px;
    height: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px;
    .el-image{
      width: 20px;
      height: 20px;
      border-radius: 5px;
      object-fit: contain;
    }
    /deep/.userAvatar{
      line-height: 20px;
      font-size: 12px;
      border-radius: 5px;
      text-align: center;
      background-color: var(--theme-color);
      color: #fff;
    }
    .name{
      margin-left: 5px;
      font-size: 12px;
      line-height: 28px;
    }
    i{
      margin-left: 5px;
      font-size: 14px;
      line-height: 28px;
      cursor: pointer;
    }
    .noClick{
      cursor: not-allowed;
    }
  }
  .users:hover{
    background-color: #ebeef5;
  }

}
</style>
